import type { RenderComponentProps } from "../../../shared/types";

import * as React from "react";

import {
  ReploElementContext,
  useRuntimeContext,
} from "../../../shared/runtime-context";
import { isFeatureSupported } from "../../../shared/utils/supportedFeatures";
import { SharedShopifyLiquid } from "../SharedShopifyLiquid";

const ShopifyAppBlocks: React.FC<RenderComponentProps> = ({
  component,
  componentAttributes,
}) => {
  const liquid = `
  {% for block in section.blocks %}
    {% case block.type %}
      {% when '@app' %}
        {% render block %}
    {% endcase %}
  {% endfor %}
  `;
  const { elementType } = useRuntimeContext(ReploElementContext);
  return (
    <SharedShopifyLiquid
      liquidSource={liquid}
      placeholderType="productOptions"
      title="Shopify App Blocks"
      componentId={component.id}
      componentAttributes={componentAttributes}
      isLiquidSupported={isFeatureSupported(elementType, "shopifyLiquid")}
    />
  );
};

export default ShopifyAppBlocks;
